import { render } from "./builderPopup.vue?vue&type=template&id=365192e6&scoped=true"
import script from "./builderPopup.vue?vue&type=script&lang=js"
export * from "./builderPopup.vue?vue&type=script&lang=js"

import "./builderPopup.vue?vue&type=style&index=0&id=365192e6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-365192e6"]])

export default __exports__